<template>
  <div id="header">
    <div class="header-grid">
      <div class="header-title-row">
        <h1 class="title is-3 has-text-centered">{{ appDisplayName }}</h1>
        <a href="#" class="light_circle" @click="is_popup_open = true" title="Help">?</a>
      </div>

      <div id="header_image">
        <a href="https://cps.ipums.org/cps">
          <img src="https://assets.ipums.org/_img/logo-CPS.png" alt="IPUMS CPS" />
        </a>
      </div>
      <div id="topics_legend">
        <div class="columns">
          <div class="column is-2 has-text-white" id="select_all_topics">
            <input type="checkbox" id="select_all_topics_checkbox" @click="all_topics_or_none" checked />
            <label for="select_all_topics_checkbox">Select All</label>
          </div>
        </div>
        <div class="columns is-mobile" v-for="supplement_groups in supplement_group_of_6()">
          <div class="column" v-for="topic in supplement_groups" :class="get_topic_class(topic)">
            <input type="checkbox" :id="get_topic_id(topic)" :checked="all_supplement_topics[topic]['picked']" @click="toggle_topic($event, topic);unselect_all_topics($event)">
            <label :for="get_topic_id(topic)">{{all_supplement_topics[topic].name}}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { inject } from 'vue';

const appDisplayName = inject('appDisplayName');
const is_popup_open = inject('is_popup_open');

const props = defineProps({
  all_supplement_topics: {type: Object, default: {}}
});

const emit = defineEmits(['update:all_supplement_topics']);

const get_topic_id = (supplement_topic) => {
  var i = props.all_supplement_topics[supplement_topic].index + 1;
  return "supplement_topic_checkbox"+(i);
}

const supplement_group_of_6 = () => {
  var results = [];
  var supplement_topics = Object.keys( props.all_supplement_topics );

  while (supplement_topics.length > 0){
    results.push(supplement_topics.splice(0, 6));
  }
  return results;
}

const get_topic_class = (supplement_topic) => {
  var i = props.all_supplement_topics[supplement_topic].index + 1;
  return "supplement_topic_"+(i);
}

const toggle_topic = (event, topic) => {
  const updated = { ...props.all_supplement_topics };
  updated[topic].picked = (event.target.checked === true);
  emit('update:all_supplement_topics', updated);
}

const unselect_all_topics = (event) => {
  if(event.target.checked === true){
    var total_checked_boxes = document.getElementById("topics_legend").querySelectorAll("input:checked").length;
    var total_topics = Object.keys( props.all_supplement_topics ).length;
    if(total_checked_boxes === total_topics){
      document.getElementById("select_all_topics").getElementsByTagName("input")[0].checked = true;
    }
  } else {
    document.getElementById("select_all_topics").getElementsByTagName("input")[0].checked = false;
  }
}

const all_topics_or_none = (event) => {
  var supplement_topics = Object.keys(props.all_supplement_topics);

  if(event.target.checked){
    for(let i=0; i< supplement_topics.length; i++){
      const updated = { ...props.all_supplement_topics }
      updated[supplement_topics[i]].picked = true
      emit('update:all_supplement_topics', updated)
    }
  }else{
    for(let i=0; i< supplement_topics.length; i++){
      const updated = { ...props.all_supplement_topics }
      updated[supplement_topics[i]].picked = false
      emit('update:all_supplement_topics', updated)
    }
  }
}
</script>

<style lang="scss" scoped>

#header{
  h1 {
    text-align: center;
    margin-bottom: 10px;
    color: white;
  }

  background-color: #00263a;
  padding: 15px 30px;

  #header_image{
    grid-column: 1;
    grid-row: 1 / span 2;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #topics_legend {
    .column {
      padding: 5px;
      margin: 5px;
      font-size: 12px;
    }

    #select_all_topics {
      margin-left: 5px;
      font-size: 11px;
    }

    label {
      width: 88%;
      padding-left: 3px;
    }
    grid-column: 2;
    grid-row: 2;
  }
  .header-title-row {
    display: grid;
    grid-template-columns: auto auto;
    justify-content: center;
    gap: 0.5rem;
    padding-right: 0.2rem;
  }  
  
  #header_image img {
    width: 326px;
    height: 90px;
  }

  .header-grid {
    display: grid;
    grid-template-columns: 350px 1fr;
    grid-template-rows: auto auto;
    column-gap: 1rem;
    align-items: stretch;
  }
}
</style>